AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Astat");

AoPS.Alcumus.Models.Astat = (function () {
	// Dependencies
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		model_type: "astat",
		id_attribute: "astat_id",
		defaults: {
			code: "",
			name: "",
			xp: 0,
			level: 0,
			xp_in_level: 0,
			xp_to_next: 0,
			xp_percent: 0,
			bonus: 0,
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
		*/

		requestLoad: function (callback, context) {
			this.get("user").requestLoad(callback, context);
		},

		// Thrown inside a tooltip
		getDescription: function (code) {
			code = code || this.get("code");
			if (code === "first") {
				return "Measures how often you solve easier problems on the first try.";
			} else if (code === "hard") {
				return "Measures how often you solve problems above your level.";
			} else if (code === "second") {
				return "Measures how often you solve problems even after an incorrect answer.";
			} else if (code === "streak") {
				return "Measures how regularly you play Alcumus and keep the Bonus meter full.";
			} else if (code === "bonus") {
				return "You earn one bar per correct problem, up to 5 each day. \nYou lose bars when you skip days.";
			}
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);
		},
	});
})();
